export default __webpack_public_path__ + "static/media/Relax_primary.2a6ffdb2.jpg";